

<app-material-case-summary [status$]="status$" [bShowStatus$]="bShowStatus$" [primaryFields$]="primaryFields$" [secondaryFields$]="secondaryFields$"></app-material-case-summary>





